<template>
    <div
        v-if="isComponentReady"
        class="l-ss-c-search-result l-ss-c-search-popup-wrapper l-ss-c-search-popup-wrapper-inbuilt">
        <div
            :class="{ 'l-ss-c-search-results-wrapper-mask-hidden': isShowAgeCheckPopup }"
            class="l-ss-c-search-wrapper-mask"
            @mousedown="mousedownClose"
            @click.self="clickClose">
            <div
                :class="{
                    [`l-ss-c-search-popup-is-opened-mobile-nav`]: showMobileNavigation,
                    [`l-ss-c-search-popup-is-loading`]: isLoading,
                    [`l-ss-c-search-popup-is-masked`]: isMaskVisible,
                    'l-ss-c-complex': true,
                    ...wrapperClasses,
                }"
                class="l-ss-c-search-popup">
                <search-results-wrapper
                    :has-query="hasQuery"
                    :has-results="hasResults"
                    :store="store"
                    :search-state="searchState"
                    :query="query"
                    :total-items-count="totalItemsCount"
                    :is-results-visible="isResultsVisible"
                    :is-filters-block-visible="isFiltersBlockVisible"
                    :request-categories="requestCategories"
                    :results-category-id="resultsCategoryId"
                    :error-text-completions="errorTextCompletions"
                    :error-text-search="errorTextSearch"
                    :has-filters="hasFilters"
                    :has-loaded-once="hasLoadedOnce"
                    :is-completions-loading="isCompletionsLoading"
                    :is-search-loading="isSearchLoading"
                    :loading-by-filters="loadingByFilters"
                    :limit="limit"
                    :search-response="searchResponse"
                    :search-request-id="searchRequestId"
                    :skip="skip"
                    :offer-templates="offerTemplates"
                    :filter-items="filterItems"
                    :sort-by="sortBy"
                    :sort-dest="sortDest"
                    :currency-in-offers="currencyInOffers"
                    :filter-values="filterValues"
                    :from_completions="from_completions"
                    :search="search"
                    :is-show-signature="isShowSignature"
                    :adult-permission-confirmed="adultPermissionConfirmed"
                    @autocomplete-search="onAutocompleteSearch"
                    @params-search="params => $emit('params-search', params)"
                    @navigate-category="handleNavigateCategory"
                    @page-reload="handlePageReload"
                    @search-image="$emit('search-image', $event)"
                    @handle-search="onSearchInputAction('handle-search')"
                    @search-input-change="params => $emit('search-input-change', params)"
                    @add-to-cart="args => onSearchInputAction('add-to-cart', args)"
                    @add-to-cart-click="$emit('add-to-cart-click', $event)"
                    @remove-from-cart-click="$emit('remove-from-cart-click', $event)"
                    @age-confirmed="$emit('age-confirmed')"
                    @filters-change="filters => $emit('filters-change', filters)"
                    @filter-click="params => $emit('filter-click', params)"
                    @toggle-filters="toggleFilters"
                    @sort-change="params => $emit('sort-change', params)"
                    @result-sort-click="params => $emit('result-sort-click', params)"
                    @reset-filters="() => $emit('reset-filters')"
                    @reset-query="() => $emit('reset-query')"
                    @navigate-page-next="() => $emit('navigate-page-next')"
                    @navigate-page-prev="() => $emit('navigate-page-prev')"
                    @button-image-click="event => $emit('button-image-click', { type: 'buttonImageClick', event })"/>

                <!--                <div-->
                <!--                    v-if="$configuration.showInput"-->
                <!--                    :style="topSectionWrapperStyles"-->
                <!--                    class="l-ss-c-search-result-top-section-wrapper l-ss-c-search-popup-content-wrapper-child">-->
                <!--                    <section-results-info-->
                <!--                        :search="search"-->
                <!--                        :total-items-count="totalItemsCount"-->
                <!--                        @autocomplete-search="$emit('autocomplete-search', $event)"-->
                <!--                        @params-search="$emit('params-search', $event)"/>-->
                <!--                </div>-->
                <!--                <div-->
                <!--                    v-show="isMaskVisible"-->
                <!--                    class="l-ss-c-search-popup-mask"-->
                <!--                    @click="onPopupMaskClick"></div>-->
                <!--                <popup-->
                <!--                    :opened="store.state.ui.isFiltersOpened"-->
                <!--                    :show-close-icon="false"-->
                <!--                    class="l-ss-c-search-popup-filters-popup"-->
                <!--                    @close="() => toggleFilters(false)">-->
                <!--                    <section-full-filters-->
                <!--                        :filters="filterItems"-->
                <!--                        :has-results="hasResults"-->
                <!--                        :has-selected="hasFilters"-->
                <!--                        :total-items-count="totalItemsCount"-->
                <!--                        :values="filterValues"-->
                <!--                        @change="filters => $emit('filters-change', filters)"-->
                <!--                        @close="() => toggleFilters(false)"-->
                <!--                        @reset="() => $emit('reset-filters')"/>-->
                <!--                </popup>-->

                <!--                <age-check-popup-->
                <!--                    v-if="isShowAgeCheckPopup"-->
                <!--                    :is-show="true"-->
                <!--                    @close="() => toggleAgeCheckPopup(false)"-->
                <!--                    @deny="onDenyAgeCheck"/>-->

                <!--                <div-->
                <!--                    class="l-ss-c-search-result-content-wrapper"-->
                <!--                    :class="{-->
                <!--                        'l-ss-c-search-popup-content-wrapper-with-result': isResultsVisible && totalItemsCount-->
                <!--                    }">-->
                <!--                    <section-image-->
                <!--                        v-if="(store.state.ui.isImageContours || base64Image)"-->
                <!--                        :base-image="base64Image"-->
                <!--                        @search="onImageSearch"/>-->

                <!--                    <div-->
                <!--                        v-if="instance.controller.isLoadingNewOffers"-->
                <!--                        class="l-ss-c-results-loader">-->
                <!--                        <pulse-dots/>-->
                <!--                    </div>-->

                <!--                    <div-->
                <!--                        v-else-->
                <!--                        :class="{ 'l-ss-c-filters-left': filterPositionLeft }"-->
                <!--                        :style="!$configuration.showInput ? 'padding-top: 0' : ''">-->
                <!--                        <div class="l-ss-c-popup-slot-top">-->
                <!--                            <section-results-info-->
                <!--                                v-if="isResultsVisible && totalItemsCount"-->
                <!--                                :search="search"-->
                <!--                                :total-items-count="totalItemsCount"-->
                <!--                                @autocomplete-search="onAutocompleteSearch"-->
                <!--                                @params-search="$emit('params-search', $event)"/>-->
                <!--                        </div>-->

                <!--                        <div :class="{ 'l-ss-c-filters-left-container': filterPositionLeft }">-->
                <!--                            <section-filters-->
                <!--                                v-if="isFiltersBlockVisible && isResultsVisible"-->
                <!--                                :currency="currencyInOffers"-->
                <!--                                :filter-position-left="filterPositionLeft"-->
                <!--                                :filters="filterItems"-->
                <!--                                :has-results="hasResults"-->
                <!--                                :has-selected="hasFilters"-->
                <!--                                :show-sorting="showSorting"-->
                <!--                                :sort-by="sortBy"-->
                <!--                                :sort-dest="sortDest"-->
                <!--                                :total-items-count="totalItemsCount"-->
                <!--                                :values="filterValues"-->
                <!--                                :is-show-signature="isShowSignature"-->
                <!--                                search-type="search-results"-->
                <!--                                class="l-ss-c-search-popup-content-wrapper-child"-->
                <!--                                ref="sectionFilters"-->
                <!--                                @change="filters => $emit('filters-change', filters)"-->
                <!--                                @sort-change="params => $emit('sort-change', params)"-->
                <!--                                @reset-filters="() => $emit('reset-filters')"-->
                <!--                                @close-filters="() => toggleFilters(false)"-->
                <!--                                @open-filters="() => toggleFilters(true)"-->
                <!--                                @toggle-image-picker="event => toggleImagePicker(event)"/>-->
                <!--                            <section-results-->
                <!--                                v-if="isResultsVisible"-->
                <!--                                ref="search-results"-->
                <!--                                :categories="allCategoriesList"-->
                <!--                                :category-id="resultsCategoryId"-->
                <!--                                :error-text="requestErrorText"-->
                <!--                                :filter-position-left="filterPositionLeft"-->
                <!--                                :filters="filterItems"-->
                <!--                                :filter-values="filterValues"-->
                <!--                                :group-categories="$configuration.features.shouldGroupCategories"-->
                <!--                                :has-filters="hasFilters"-->
                <!--                                :has-loaded-once="hasLoadedOnce"-->
                <!--                                :has-query="hasQuery"-->
                <!--                                :has-results="hasResults"-->
                <!--                                :is-loading="isLoading"-->
                <!--                                :limit="limit"-->
                <!--                                :currency="currencyInOffers"-->
                <!--                                :search="searchResponse"-->
                <!--                                :search-request-id="searchRequestId"-->
                <!--                                :skip="skip"-->
                <!--                                :templates="offerTemplates"-->
                <!--                                :total-items-count="totalItemsCount"-->
                <!--                                :query="query"-->
                <!--                                :sort-by="sortBy"-->
                <!--                                :sort-dest="sortDest"-->
                <!--                                :adult-permission-confirmed="adultPermissionConfirmed"-->
                <!--                                :is-show-signature="isShowSignature"-->
                <!--                                class="l-ss-c-search-popup-content-wrapper-child"-->
                <!--                                @navigate-category="handleNavigateCategory"-->
                <!--                                @navigate-page-next="() => $emit('navigate-page-next')"-->
                <!--                                @navigate-page-prev="() => $emit('navigate-page-prev')"-->
                <!--                                @reset-category="() => $emit('navigate-category', emitNavigateCategory({ skip: 0, categoryId: '' }))"-->
                <!--                                @offer-click="params => $emit('offer-click', params)"-->
                <!--                                @add-to-cart="args => onSearchInputAction('add-to-cart', args)"-->
                <!--                                @reset-filters="() => $emit('reset-filters')"-->
                <!--                                @reset-query="() => $emit('reset-query')"-->
                <!--                                @handle-tags-click="(value) => onTapAction(value)"-->
                <!--                                @sort-change="$emit('sort-change', $event)"-->
                <!--                                @filters-change="handleChangeFiltersFromResults"-->
                <!--                                @result-sort-click="$emit('result-sort-click', $event)"-->
                <!--                                @autocomplete-search="onAutocompleteSearch"-->
                <!--                                @page-reload="handlePageReload"-->
                <!--                                @scroll-to-top="handleScrollToTop"/>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
    import { installPlugins } from '../core/plugins';
    import RootComponentMixin from '../core/mixins/root-component';
    import CompletionsMixin from '../core/mixins/completions';
    import SearchResultsMixin from '../core/mixins/search-results-mixin';
    import iconClosePopup from '../core/assets/images/icons/close-popup.svg';
    import { getCookie } from '/src/core/helpers/cookies';
    import SearchResultsWrapper from '@/core/components/search-results/search-results-wrapper.vue';

    const EVENT_CALLBACK_DELAY = 300;
    // Const POPOVER_Z_INDEX = 52;
    installPlugins();
    export default {
        components: {
            SearchResultsWrapper,
        },
        provide: RootComponentMixin.provide,
        props: {
            ...CompletionsMixin.props,
            ...RootComponentMixin.props,
            ...SearchResultsMixin.props,
            from_completions: {
                type: String,
                default: '',
            },
            categoryId: {
                type: [String, Number],
                default: '',
            },
            query: {
                type: String,
                default: '',
            },
            params: {
                type: Array,
                default: () => ([]),
            },
            completions: {
                type: Array,
                required: false,
                default: () => ([]),
            },
            requestCategories: {
                type: Object,
                required: false,
                default: () => null,
            },
        },
        data() {
            return {
                localQueryParams: null,
                showMobileNavigation: false,
                base64Image: null,
                showSearch: true,
                wrapperClickTarget: null,
                sectionImageKey: '',
            };
        },

        computed: {
            ...CompletionsMixin.computed,
            ...RootComponentMixin.computed,
            ...SearchResultsMixin.computed,
            isMaskVisible() {
                return this.store.state.ui.isImageSearchVisible ||
                    this.store.state.ui.isCategoriesListVisible ||
                    this.store.state.ui.isFiltersOpened ||
                    this.showCompletions;
            },
            iconClosePopup() {
                return iconClosePopup;
            },
            isCategoriesLoading() {
                return this.requestCategories ? this.requestCategories.isLoading : false;
            },
            isLoading() {
                return this.isCompletionsLoading || this.isSearchLoading || this.isCategoriesLoading;
            },
            isShowAgeCheckPopup() {
                return this.store.state.ui.isShowAgeCheckPopup;
            },
            hasImageSearchResults() {
                return Boolean(this.searchState.private && this.searchState.private.image);
            },
            image() {
                return this.hasImageSearchResults ? this.searchState.private.image : '';
            },
        },

        watch: {
            'searchState.public': function (state) {
                if (this.localQueryParams && this.localQueryParams.query !== state.query) {
                    this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchVisible', value: false });
                }
                this.localQueryParams = state ? { ...state } : {};
            },

            'store.state.ui.isCompletionsVisible': {
                handler(value) {
                    if (value && !this.isFocused && this.value) {
                        this.$refs.input.focus();
                        this.isFocused = true;
                    }
                },
            },
        },

        beforeCreate() {
            Object.assign(this, { projectName: 'SearchBooster.io' });
            Object.assign(this, { href: 'https://searchbooster.io/' });
        },

        mounted() {
            this.$on('search-input-change', () => {
                this.base64Image = null;
                this.base64ImageResult = null;
            });
            this.$on('handle-search', () => {
                this.base64Image = null;
                this.base64ImageResult = null;
            });
            this.addCss(this.$configuration.searchResult.topBlock.customCss);
        },

        updated() {
            this.setValueToSignature();
        },

        methods: {
            ...RootComponentMixin.methods,
            ...SearchResultsMixin.methods,
            addCss(cssCode) {
                let shDom = document.querySelector('searchbooster-search-results');
                let style = document.createElement('style');
                if (style.styleSheet) {
                    style.styleSheet.cssText = cssCode;
                } else {
                    style.appendChild(document.createTextNode(cssCode));
                }
                shDom.shadowRoot.appendChild(style);
            },
            clickClose(event) {
                if (this.wrapperClickTarget === event.target) this.$emit('search-popup-close');
            },
            mousedownClose(event) {
                this.wrapperClickTarget = event.target;
            },
            toggleImageSearch(value) {
                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isImageSearchVisible',
                    value: value === undefined ? !this.store.state.ui.isImageSearchVisible : !!value,
                });
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchLoader', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });
                this.base64Image = null;
                this.base64ImageResult = null;
            },
            toggleAgeCheckPopup() {
                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isShowAgeCheckPopup',
                    value: !this.store.state.ui.isShowAgeCheckPopup,
                });
            },
            onSearchInputAction(eventName, params) {
                let afterEventCallback = null;
                switch (eventName) {
                    case 'search-input-change':
                        this.$emit(eventName, params);
                        break;
                    case 'handle-search':
                        this.toggleFilters(false);
                        this.$emit(eventName);
                        break;
                    case 'toggle-image-picker':
                        this.toggleImageSearch(params);
                        break;
                    case 'popup-close':
                        this.$emit('search-popup-close');
                        break;
                    case 'search-input-blur':
                        this.$emit('search-input-blur');
                        break;
                    case 'search-input-focus':
                        this.$emit('search-input-focus');
                        break;
                    case 'search-input-enter':
                        this.$emit(eventName, params);
                        break;
                    case 'reset-query':
                        this.base64Image = null;
                        this.$emit(eventName, params);
                        break;
                    case 'add-to-cart':
                        this.$emit(eventName, params);
                        break;
                    case 'remove-history':
                        this.$emit('remove-history');
                        break;
                    default:
                        afterEventCallback = () => {
                            this.showSearch = true;
                        };
                        this.$emit(eventName, params);
                }
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                if (afterEventCallback) {
                    setTimeout(afterEventCallback, EVENT_CALLBACK_DELAY);
                }
            },
            setValueToSignature() {
                if (!this.isShowSignature)
                    return;
                const i18nStr = this.$t('signature', [this.projectName]);
                const preparedValue = i18nStr.replace(this.projectName, '');
                const refsList = i18nStr.indexOf(this.projectName) === 0
                    ? [this.$refs.signatureLeft, this.$refs.signatureRight]
                    : [this.$refs.signatureRight, this.$refs.signatureLeft];
                if (!refsList.some(Boolean))
                    return;
                refsList[0].innerText = this.projectName;
                refsList[0].href = this.href;
                refsList[0].target = '_blank';
                refsList[1].innerText = preparedValue;
            },
            onDenyAgeCheck() {
                if (this.$configuration.features.ageCheckPopupType === 'filter') {
                    this.$emit('search-all');
                } else {
                    this.$emit('reset-query');
                    this.$emit('search-popup-close');
                    window.location.href = getCookie('ageCheckPopupRedirectUrl', this.$configuration.ageCheckPopupRedirectUrl);
                }
            },
            onAutocompleteSearch(value) {
                this.$emit('autocomplete-search', value);
            },
        },
    };
</script>
